import { render, staticRenderFns } from "./IconNews.vue?vue&type=template&id=721d368e&"
import script from "./IconNews.vue?vue&type=script&lang=js&"
export * from "./IconNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports